export const entityName = 'Students';
